import styled from 'styled-components';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';

export const LoanSummaryWrapper = styled.div`
  max-width: 912px;
  background: #ffffff;
  border: 1px solid #d9dde9;
  box-sizing: border-box;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  border-radius: 8px;
  margin: 0 auto;
  overflow: hidden;
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
    align-items: flex-end;
  }
`;

export const PaidOffContentWrapper = styled(ContentWrapper)`
  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-top: -16px;
  }
`;

export const Content = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  // min-height: 84px;
  justify-content: space-between;
  align-items: flex-start;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-bottom: 0;
  }
`;

export const Button = styled(SecondaryButton)`
  margin: 0;
  min-height: 40px;
  word-break: break-word;
  padding: 0 24px;
  min-width: auto !important;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    min-width: 200px !important;
  }

  /* Less than 375px */
  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    padding: 12px 24px;
  }
`;

export const MessageTileWrapper = styled.div`
  display: flex;
  flex-direction: row;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
  }
`;

export const Caption = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding-top: 24px;
`;
